/**
 * Sprint 29 (Wave 1) + 31 (Wave 2) · Home Décor locale aggregator.
 * Wave 1: DE, FR, ES — full-depth hand-authored (3 sections + 4 FAQs per page).
 * Wave 2: IT, NL — full-depth hand-authored.
 * Wave 2 pending (next sprint): SV, DA, FI, AR — plug in a new import below.
 */
import { DE_SHARED, DE_PAGES } from "./homeDecorLocalesDe";
import { FR_SHARED, FR_PAGES } from "./homeDecorLocalesFr";
import { ES_SHARED, ES_PAGES } from "./homeDecorLocalesEs";
import { IT_SHARED, IT_PAGES } from "./homeDecorLocalesIt";
import { NL_SHARED, NL_PAGES } from "./homeDecorLocalesNl";

export const HOME_DECOR_WAVE1_LOCALES = ["de", "fr", "es", "it", "nl"];

const BAGS = {
  de: { shared: DE_SHARED, pages: DE_PAGES },
  fr: { shared: FR_SHARED, pages: FR_PAGES },
  es: { shared: ES_SHARED, pages: ES_PAGES },
  it: { shared: IT_SHARED, pages: IT_PAGES },
  nl: { shared: NL_SHARED, pages: NL_PAGES },
};

export function getHomeDecorTranslation(locale, slug) {
  const bag = BAGS[locale];
  if (!bag) return null;
  const t = bag.pages[slug];
  if (!t) return null;
  return { ...t, shared: bag.shared, locale, englishSlug: slug };
}

export const HOME_DECOR_TRANSLATED_SLUGS = Object.fromEntries(
  Object.entries(BAGS).map(([lc, b]) => [lc, Object.keys(b.pages)])
);
